import * as React from "react";
import { getRmDetails } from "../../service/serviceRequest/srApiService";

interface FailedValidationScreen {
  headerText: string;
  desc: string;
}
export const FailedValidationScreen = (props: any) => {
  const [userRmName, setUserRmName] = React.useState("");
  React.useEffect(() => {
    getDetailsRm();
  }, []);
  const getDetailsRm = async () => {
    const localStorageDetails: any = localStorage.getItem("acc_data");
    const rmObj = {
      name: JSON.parse(localStorageDetails).userID,
      type: JSON.parse(localStorageDetails).accTyp,
    };
    let reqObj = `?acctype=${rmObj.type}&accode=${rmObj.name}`;
    try {
      let response = await getRmDetails(reqObj);
      setUserRmName(response.rmNm);
    } catch (error) {
      props.onSubmit("FATCA Update", {
        headerText:
          "There was some problem in raising service request. Please try again later.",
      });
    }
  };
  return (
    <>
      <div className="failed-validate">
        <div className="validate_wrap">
          <div className="validate">
            <div className="validate__dots">
              <div className="failed-icon">
                <span className="edel-icon-close"></span>
              </div>
            </div>
          </div>

          <div className="text">
            <p className="field-head text-center head">{props.headerText}</p>
            <p className="field-subHead desc text-center grey-text">
              {props.desc}
            </p>
            <p className="field-head text-center">{userRmName}</p>
            <p className="text-center">
              <a href="mailto:helpdesk@nuvama.com" className="mail_link">
                helpdesk@nuvama.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
